import AjaxBuilder from '../../../../Common/AjaxBuilder';
import { Util } from '../../../../Common/Util';
import Vocabulary from "../../../../Common/Vocabulary";

export class City {
    constructor({ module, lang }) {
        this.$searchModule = module;
        this._lang = lang;
        this._aviaCities = [];
        this._aviaAirports = [];

        this._searchCityRoute = `${Util.getLocalization()}avia/api/search_city/`;
        this._searchPopularCitiesRoute = `${Util.getLocalization()}avia/api/get_popular_cities/`;

        // this.initializeSelectedCitiesFromUrl();

        //TODO::поправить
        $(document).mouseup(function (e) {
            let open_loc_from = $('.widget_input__from .widget_locations._show'),
                open_loc_from_input = $('.widget_input__from input');
            if (!open_loc_from.is(e.target) && open_loc_from.has(e.target).length === 0
                && !open_loc_from_input.is(e.target)) {
                const selectedItem = open_loc_from.find('._selected');
                if (open_loc_from.length > 0 && selectedItem.length < 1) {
                    open_loc_from_input.val('');
                }

                $('.widget_input__from .widget_locations._show').removeClass('_show');
            }

            let open_loc_to = $('.widget_input__to .widget_locations._show'),
                open_loc_to_input = $('.widget_input__to input');
            if (!open_loc_to.is(e.target) && open_loc_to.has(e.target).length === 0
                && !open_loc_to_input.is(e.target)) {
                const selectedItem = open_loc_to.find('._selected');
                if (open_loc_to.length > 0 && selectedItem.length < 1) {
                    open_loc_to_input.val('');
                }
                $('.widget_input__to .widget_locations._show').removeClass('_show');
            }


            let open_passengers = $('.passengers_select._show');
            if (!open_passengers.is(e.target) && open_passengers.has(e.target).length === 0) {
                $('.passengers_select._show').removeClass('_show');
            }

        });
    }

    getSelectedCity() {
        if (!this._aviaCities.length || !this._selectedCityElement) {
            console.error('No cities or airports are selected, or _aviaCities/_aviaAirports is empty.');
            return null;
        }

        const code = Number(this._selectedCityElement.data('id'));

        // Спочатку шукаємо місто за кодом міста.
        let city = this._aviaCities.find(city => city.id === code);

        // Якщо місто не знайдено, шукаємо аеропорт за кодом аеропорту в усіх містах.
        if (!city) {
            for (const cityObj of this._aviaCities) {
                const airport = cityObj.airports.find(airport => airport.id === code);

                if (airport) {
                    // Якщо аеропорт знайдено, присвоюємо його місто змінній city.
                    city = {
                        id: airport.id,
                        code: airport.code,
                        name_en: airport.name_en,
                        value: airport.name,
                    };
                    break;
                }
            }
        } else {
            city = {
                id: city.id,
                code: city.city_code,
                name_en: city.name_en,
                value: city.value,
            };
        }

        if (city) {
            return city;
        } else {
            console.error('Selected city or airport with code ' + code + ' not found.');
            return null;
        }
    }

    getQueryParam(param) {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get(param);
    }

    initializeSelectedCitiesFromUrl() {
        const url = new URL(window.location.href);
        const pathSegments = url.pathname.split("/");

        let locale;
        if (pathSegments[1] === "ru") {
            // Якщо локалізація - російська
            locale = "ru";
        } else {
            // В іншому випадку вважаємо, що локалізація - українська (можна додати інші перевірки)
            locale = "ua";
        }

        const cityFromCode = pathSegments[locale === "ru" ? 6 : 5];
        const cityToCode = pathSegments[locale === "ru" ? 7 : 6];

        if (cityFromCode && cityToCode) {
            // Перевірка, чи є такі коди у _aviaCities
            let cityFrom = this._aviaCities.find(city => city.code === cityFromCode);
            let cityTo = this._aviaCities.find(city => city.code === cityToCode);

            if (cityFrom && cityTo) {
                this._cityFrom.setSelectedElement(cityFrom);
                this._cityTo.setSelectedElement(cityTo);
            }
        }
    }

    setAllAirports(airports) {
        this._aviaAirports = airports;
    }

    //Это 3 метода нужны для свапа городов местами (getAllCities, setAllCities, setSelectedElement)
    //Получить все найденные города
    getAllCities() {
        return this._aviaCities;
    }
    // Добавить найденные города
    setAllCities(cities) {
        this._aviaCities = cities;
        this._createCityList();
    }
    // Добавить элемент выбранного города из списка
    setSelectedElement(city) {
        const cityElement = this._aviaCities.find(c => c.city_code === city.code);

        if (!cityElement) {
            this._selectedCityElement = this.$locationWrapper.find(`.city_list .airport_item[data-code="${city.code}"]`);
            $(this._selectedCityElement).addClass('_selected');
            this.$inputElement.val(city.value);
        } else {
            this._selectedCityElement = this.$locationWrapper.find(`.city_list .city_item[data-code="${cityElement.city_code}"]`);
            $(this._selectedCityElement).addClass('_selected');
            this.$inputElement.val(cityElement.city_name);
        }

    }


    _takeSelectedCity(type) {
        return this.$searchModule.find(`input[name="${type}"]`).val();
    }

    _getPopularCities(type) {
        new AjaxBuilder({
            route: this._searchPopularCitiesRoute,
            data: {
                type: type,
            }
        }, 'GET').execute({
            success: (data) => {
                this._aviaCities = data.response.cities;
                this._popularCities = data.response.cities;

                this._createCityList('popular');
            }
        })
    }

    //Поиск городов в базе
    _searchCityHandler(event) {
        const searchedCity = this.$inputElement.val();

        $(this.$locationWrapper).addClass('_show');
        this._showLoader();

        clearTimeout(this._timer);
        this._timer = setTimeout(() => {
            new AjaxBuilder({
                route: this._searchCityRoute,
                data: {
                    city: searchedCity,
                },
            }, 'GET').execute({
                success: this._searchCitySuccess.bind(this),
                error: this._searchCityError.bind(this),
            });
        }, 1000);
    }

    //Успешный поиск городов в базе
    _searchCitySuccess(data) {
        const cities = Object.values(data.response.cities);
        if (cities.length > 0) {
            this._aviaCities = cities.sort((a, b) => a.value.localeCompare(b.value));

            this._createCityList();
            return;
        }
        this.$locationWrapper.html(`
            <div class="widget_locations_title">${Vocabulary[this._lang].cities_not_found}</div>
        `);
    }

    //Поиск городов в базе с ошибкой
    _searchCityError(data) {
        this.$locationWrapper.html(`
            <div class="widget_locations_title">${Vocabulary[this._lang].cities_not_found}</div>
        `);
    }

    //Создает список из найденных городов
    _createCityList(type = 'default') {
        const list = this._aviaCities.map(city => {
            let cityItem = `<li class="city_item _location_flex _location_parent" data-id="${city.id}" data-code="${city.city_code}" data-name="${city.city_name}">
                            <div class="_location_flex_left">
                                <img src="${window.location.origin}/frontend-assets/images_new/ico/widget_locations_loc.svg" alt="icon">
                                ${city.city_name} <span>,${city.country_name}</span>
                            </div>
                            <div class="_location_flex_right">${city.city_code}</div>
                        </li>`;

            // Перевірка чи існують аеропорти для цього міста
            let airportsItems = '';

            if (city.airports && Array.isArray(city.airports)) {
                airportsItems = city.airports.map(airport => {
                    return `<li class="airport_item _location_flex _location_child" data-id="${airport.id}" data-code="${airport.code}" data-name="${airport.name}">
                            <div class="_location_flex_left">
                                <img src="${window.location.origin}/frontend-assets/images_new/ico/widget_locations_flight.svg" alt="">
                                ${airport.name} <span>,${city.city_name}</span>
                            </div>
                        <div class="_location_flex_right">${airport.code}</div>
                    </li>`;
                }).join('');
            }

            return cityItem + airportsItems;
        }).join('');

        this.$locationWrapper.html(`<ul class="city_list">${list}</ul>`);
    }


    //Сам обработчик выбора города из списка
    _cityHandler(event) {
        event.preventDefault();
        let element = $(event.target).closest('li');

        if (element.hasClass('city_item') || element.hasClass('airport_item')) {
            if (this._selectedCityElement) $(this._selectedCityElement).removeClass('_selected');
            this._selectedCityElement = element;
            $(element).addClass('_selected');

            let selectedValue = element.data('name');
            let cityCode = element.data('code'); // Додайте збереження city_code
            // Можете зберегти й інші параметри, якщо це необхідно

            this.$inputElement.val(selectedValue);
            this.$locationWrapper.removeClass('_show');
        }
    }

    _showLoader() {
        if ($('.location_loader').length > 0) return;
        this.$locationWrapper.html('<div class="location_loader"><div></div><div></div><div></div><div></div></div>');
    }
}
